const OrganicPaidPostType = Object.freeze({
  TIMELINE: 'Timeline',
  TARGETED: 'Targeted'
})
export default OrganicPaidPostType
export type OrganicPaidPostTypeStrings = typeof OrganicPaidPostType[keyof typeof OrganicPaidPostType]
// RESERVE BELOW
